import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { useApi } from '../../hooks/useApi';
import { Donor, ApiDonor } from '../../models/Donor';
import Spinner from '../../components/Spinner';
import DonorCard from '../../components/DonorCard';
import IconGuide from '../../components/IconGuide';

// ループに必要なスライド数。PC の slidesPerView(3) の2倍。
const LOOP_MIN_SLIDES = 6;

const RecommendedDonors = () => {
  const [ apiDonors, setApiDonors ] = useState<ApiDonor[]>([]);
  const [ loaded, setLoaded ] = useState(false);
  const { get } = useApi();

  useEffect(() => {
    get({
      endpoint: `/api/v1/donors/recommended`,
      skipAuth: true,
      onSuccess: (res) => {
        setApiDonors(res?.data || []);
        setLoaded(true);
      },
      onError: (err) => {
        console.error(err.message);
        setLoaded(true);
      },
    });
  }, [ get ])

  const donors = apiDonors.map(apiDonor => new Donor(apiDonor));

  // ドナーが少ないとループが成立せず Swiper が警告を出すため、必要数まで複製して埋める
  const slideDonors = donors.length > 0 && donors.length < LOOP_MIN_SLIDES
    ? Array.from({ length: LOOP_MIN_SLIDES }, (_, i) => donors[ i % donors.length ])
    : donors;

  const donorItems = slideDonors.map((donor, index) => (
    <SwiperSlide key={ `${ donor.userNo }-${ index }` }>
      <DonorCard donor={ donor } />
    </SwiperSlide>
  ));

  return (
    <section className="donor">
      <h2 className="sec_title">性病検査済みおすすめドナー</h2>
      <div className="swiper donor_list">
        <div className="swiper-container">
          { !loaded ? (
            <Spinner centered />
          ) : donorItems.length > 0 && (
            <Swiper
              modules={[Autoplay, Navigation]}
              breakpoints={{
                750: {
                  slidesPerView: 3,
                  spaceBetween:  40
                }
              }}
              spaceBetween={ 50 }
              slidesPerView={ 1 }
              autoplay={{ delay: 3000 }}
              loop={ true }
              speed={ 500 }
              navigation={{
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
              }}
            >
              { donorItems }
            </Swiper>
          ) }
        </div>
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </div>
      <div className="icon-guide-wrap">
        <IconGuide />
      </div>
      <div className="more-link">
        <Link to="/search-result?std_certified_only=TRUE&kyc_certified_only=TRUE" className="w_bluebtn">もっと見る</Link>
      </div>
    </section>
  );
}

export default RecommendedDonors;
